import { formatDateISO } from "../screens/common";
import { commonStrings } from "./StringBundle";

// generate payload for filter and params
export function generateFilterPayload(payloadArr, params){
    let payload = {};
    let payloadQuery = [];
    payloadArr?.map(item => {
      let value = item.searchText;
      if (item.type === "date" && value) {
        value = formatDateISO(value, "YYYY-MM-DD");
      }
        payloadQuery?.push({key: item.searchedColumn, value });
    })    
    payload = {"filters": payloadQuery, params:params}
    return payload;
}

// generate payload for list apis
export function transformData(inputData) {
    return {
      filters: inputData.filters || [],
      ...(inputData.params || {}) 
      // Spread all key-value pairs from params dynamically
    };
  }

// Grid Table SearchFilter Function
export const resolveSearchFilters = (overrideFilters, existingFilters = []) => {
  return overrideFilters?.length > 0 ? overrideFilters : existingFilters || [];
};